/**
 * Export Excel de la liste des produits en alerte de stock (modal d'accueil).
 * Même dépendance (xlsx) et même approche que salesSummaryExport.js.
 *
 * @param {Array<{name: string, stock: number, stock_alert: number}>} rows
 * @param {Object} options
 * @param {string} [options.filename]
 * @param {string} [options.businessName]
 */
export function exportStockAlertsExcel(rows, options = {}) {
  const XLSX = require('xlsx')

  const etat = (r) => (Number(r.stock) <= 0 ? 'Rupture' : 'Stock faible')

  const header = ['Produit', 'Stock actuel', 'Seuil d’alerte', 'État']
  const body = rows.map((r) => [
    r.name,
    Number(r.stock),
    Number(r.stock_alert) > 0 ? Number(r.stock_alert) : '—',
    etat(r),
  ])

  const aoa = []
  if (options.businessName) {
    aoa.push([options.businessName])
    aoa.push(['Produits en alerte de stock'])
    aoa.push([])
  }
  aoa.push(header)
  body.forEach((line) => aoa.push(line))

  const ws = XLSX.utils.aoa_to_sheet(aoa)
  ws['!cols'] = [{ wch: 40 }, { wch: 14 }, { wch: 14 }, { wch: 14 }]

  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, 'Alertes de stock')
  XLSX.writeFile(wb, options.filename || 'alertes_de_stock.xlsx')
}
